import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useParams, useNavigate } from "react-router-dom";
import "./complaintDetail.scss";
import Footer from "Common/Footer";
import { Button, Card } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";
import { ComplaintWarningTypeLabel } from "Constants/Enums/Complaint/TypeOfWarning";
import dayjs from "dayjs";

function ViewCorrectiveDetail() {
  const { id } = useParams();
  const complaintId = id;
  const navigate = useNavigate();
  const [complaintDetail, setComplaintDetail] = useState([]);

  const backtoComplaint = () => {
    navigate("/complaints");
  };

  useEffect(() => {
    async function fetchComplaintDetail() {
      try {
        const response = await axiosInstance.get(
          API.correctiveAction.getListByComplaint(complaintId)
        );
        const data = Array.isArray(response.data) ? response.data : [response.data];
        setComplaintDetail(data);
      } catch (error) {
        console.error("Error fetching corrective detail:", error);
      }
    }
    fetchComplaintDetail();
  }, [complaintId]);

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <div className="body flex-grow-1 px-3">
          <br />
          <br />

          <Card
            className="card-professional"
            title="Corrective Complaint Details"
            extra={
              <Button type="default" onClick={backtoComplaint}>
                Back to Complaints
              </Button>
            }
          >
            {complaintDetail.length === 0 ? (
              <p>No corrective actions found.</p>
            ) : (
              complaintDetail.map((detail, index) => (
                // CHANGE THE OUTER DIV STYLE:
                <div
                  key={index}
                  style={{
                    background: "#fff",
                    borderLeft: "4px solid #10b981", // Emerald accent
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    borderRadius: "8px",
                    padding: "20px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Complaint Against Info */}
                  <div className="complaintAction mb-2">
                    <h6>Complaint Against Full Name</h6>
                    <span>
                      {detail.complaintAgainstFirstName} {detail.complaintAgainstLastName}
                    </span>
                  </div>
                  <div className="complaintAction mb-2">
                    <h6>Complaint Against Email</h6>
                    <span>{detail.complaintAgainstEmail}</span>
                  </div>
                  <div className="complaintAction mb-2">
                    <h6>Department Name</h6>
                    <span>{detail.departmentName || "N/A"}</span>
                  </div>
                  <div className="complaintAction mb-2">
                    <h6>Date Of Incident</h6>
                    <span>{dayjs(detail.timeOfIncident).format("DD MMM YYYY, HH:mm")}</span>
                  </div>
                  <div className="complaintAction mb-2">
                    <h6>Complaint Type</h6>
                    <span>{detail.complaintTypeName}</span>
                  </div>
                  <div className="complaintAction mb-2">
                    <h6>Complaint Detail of Incident</h6>
                    <div className="incident-detail">
                      <span>{detail.detailOfIncident}</span>
                    </div>
                  </div>

                  {/* Map through corrective actions */}
                  {detail.correctiveActions && detail.correctiveActions.length > 0 ? (
                    detail.correctiveActions.map((action, idx) => (
                      <div
                        key={idx}
                        style={{
                          background: "#fff",
                          border: "1px solid #e8e8e8",
                          borderRadius: "8px",
                          padding: "12px",
                          marginTop: "12px",
                        }}
                      >
                        <div className="complaintAction mb-2">
                          <h6>Type of Warning</h6>
                          <span>{ComplaintWarningTypeLabel[action.typeOfWarning]}</span>
                        </div>
                        <div className="complaintAction mb-2">
                          <h6>Action Plan(s) for Improvement</h6>
                          <span>{action.improvement}</span>
                        </div>
                        <div className="complaintAction mb-2">
                          <h6>Associate’s Comments</h6>
                          <span>{action.associateComments}</span>
                        </div>
                        <div className="complaintAction mb-2">
                          <h6>Summary of Counseling Session</h6>
                          <span>{action.summarySession}</span>
                        </div>
                        <div className="complaintAction mb-2">
                          <h6>Leader Name</h6>
                          <span>{action.leaderName}</span>
                        </div>
                        <div className="complaintAction mb-2">
                          <h6>Action Created On</h6>
                          <span>{dayjs(action.createdOn).format("DD MMM YYYY, HH:mm")}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No corrective actions found.</p>
                  )}
                </div>
              ))
            )}
          </Card>
          <Footer />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ViewCorrectiveDetail;
